import "./style.scss";

import React, { useState } from "react";

import Media from "../Media/Media";
import RichText from "../RichText/RichText";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { Image } from "../../CmsDocuments/SectionPage/components/Section/Section";
import { BNBox, BNDialog } from "@bn-monorepo/js-packages";
import { Grid } from "@mui/material";

interface Props {
  content: {
    text: string;
    desktopImage: Image;
    mobileImage: Image;
    makeBiggerLabel: string;
  };
  counter: number;
}

const UserGuideStep: React.FC<Props> = (props) => {
  const [selectedImage, setSelectedImage] = useState<Image>();

  const openModal = (image: Image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(undefined);
  };

  const renderMedia = (device) => {
    const { desktopImage, mobileImage, makeBiggerLabel } = props.content;
    const image = device === "desktop" ? desktopImage : !!mobileImage && !!mobileImage.url ? mobileImage : desktopImage;
    return (
      <BNBox
        onClick={() => openModal(image)}
        className={"thumbnail-wrapper"}
        sx={{
          display: {
            xs: device === "mobile" ? "inline-block" : "none",
            md: device === "mobile" ? "none" : "inline-block",
          },
        }}
      >
        <Media
          className="thumbnail"
          imagePath={image.url}
          AltText={image.alt}
          maxWidth={400}
          width={image.width}
          height={image.height}
          blackAndWhite={false}
        />
        <div className="zoom">
          <ZoomInIcon
            sx={{
              fontSize: "3rem",
            }}
          />
          <span className="text">{makeBiggerLabel}</span>
        </div>
      </BNBox>
    );
  };

  const { counter, content } = props;
  const { text } = content;

  return (
    <div className="user-guide-step">
      <Grid container>
        <Grid
          size={{
            xs: 12,
            md: 2,
          }}
          sx={{
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <div className="counter">{counter}.</div>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 5,
          }}
          sx={{
            alignContent: "center",
            textAlign: "center",
            order: { xs: 2, md: 3 },
          }}
        >
          {content && content.desktopImage && renderMedia("desktop")}
          {content && content.desktopImage && renderMedia("mobile")}
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 5,
          }}
          sx={{
            alignContent: "center",
            justifyContent: "center",
            order: { xs: 3, md: 2 },
          }}
        >
          <RichText html={text} />
        </Grid>
      </Grid>
      {selectedImage && (
        <BNDialog maxWidth={"lg"} open={selectedImage !== undefined} onClose={closeModal}>
          <Media
            imagePath={selectedImage.url}
            AltText={content.desktopImage?.alt ?? ""}
            noWrapper
            width={selectedImage.width}
            height={selectedImage.height}
            blackAndWhite={false}
          />
        </BNDialog>
      )}
    </div>
  );
};

export default UserGuideStep;
